export default [
	{
		label: "First Example",
		json: require("./first-example.json")
	},
	{
		label: "Mouse Coords",
		json: require("./mouse-coords.json")
	},
	{
		label: "Audio Levels",
		json: require("./example-audio-levels-2.json")
	},
	{
		label: "Audio Spinner",
		json: require("./example-audio-spinner.json")
	},
	{
		label: "Bouncing Circles",
		json: require("./bouncing-circles.json")
	},
	{
		label: "Pixel Cam",
		json: require("./pixel-cam.json")
	},
	{
		label: "Drum SVG (TR-8S)",
		json: require("./drums-svg.json")
	},
	{
		label: "Lazer Grid",
		json: require("./lazer-grid.json")
	}
];
